import React from 'react'
import './CfoSite.css'
import { CfoBrandMark } from './CfoSiteShared'

export function CfoSyncStartedPage() {
  const provider =
    typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('provider')
      : null
  const providerName =
    provider === 'xero' ? 'Xero'
      : provider === 'sage_accounting' ? 'Sage Accounting'
        : provider === 'sage_intacct' ? 'Sage Intacct'
          : provider === 'netsuite' ? 'NetSuite'
            : 'QuickBooks'

  return (
    <div className="cfo-site">
      <div className="cfo-center">
        <div className="cfo-panel cfo-center-text">
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 18 }}>
            <CfoBrandMark sub="by FuseGrid" />
          </div>
          <div className="cfo-orb" aria-hidden="true">
            <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
              <path d="M4 16 9 10l3.5 3L20 5" style={{ stroke: '#fff', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' }} />
              <circle cx="20" cy="5" r="2" fill="#fff" />
            </svg>
          </div>
          <h1>{providerName} connected — your sync has started.</h1>
          <p className="sub" style={{ fontSize: 15.5 }}>
            We’re reading your full accounting history to build your CFO Core. Because we go all
            the way back, the initial sync usually takes a few hours — there’s nothing for you to do.
          </p>
          <p className="cfo-prose">
            <strong>We’ll email you the moment it’s ready</strong>, with a private link straight to
            your CFO Core. You can safely close this tab.
          </p>
        </div>
      </div>
    </div>
  )
}

export default CfoSyncStartedPage
